export const ItemAction = {
    Created: "item.created",
    Modified: "item.modified",
    Deleted: "item.deleted",
};
